import React, {useContext} from 'react';
import {Link} from "react-router-dom";
import {endpointImg} from "../api";
import parse from 'html-react-parser';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faCalendarAlt, 
  faUser, 
  faClock,
  faArrowRight,
  faShareAlt
} from '@fortawesome/free-solid-svg-icons';
import {LanguageContext} from "../config/multilingualContext";
import { getLabel } from "../functions/lang";
import MultiLingualContent from '../config/multilingualContent';

const NewsItem = (props) => {
  const {language} = useContext(LanguageContext);
  const {id, created_at, titleFr, titleEn, titlePr, titleSw, descFr, descEn, descPr, descSw, sampleImg} = props.blog;

  const getLocalizedTitle = () => {
    const title = getLabel({
      label_fr: titleFr,
      label_en: titleEn,
      label_pr: titlePr,
      label_sw: titleSw,
    }, language);
    return title || 'No title available';
  };

  const getLocalizedDesc = () => {
    const desc = getLabel({
      label_fr: descFr,
      label_en: descEn,
      label_pr: descPr,
      label_sw: descSw,
    }, language);
    return desc || 'No description available';
  };

  const cleanHTML = (html) => {
    if (!html) return '';
    // Remove HTML tags and limit length
    const plainText = html.replace(/<[^>]*>?/gm, '').replace(/&nbsp;/g, ' ');
    return plainText.length > 120 ? plainText.substring(0, 120) + '...' : plainText;
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = date.getDate().toString().padStart(2, '0');
    const month = date.toLocaleString('default', { month: 'short' });
    const year = date.getFullYear();
    return { day, month, year };
  };

  const dateInfo = formatDate(created_at);

  const handleShare = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (navigator.share) {
      navigator.share({
        title: getLocalizedTitle(),
        text: cleanHTML(getLocalizedDesc()),
        url: window.location.origin + '/new/' + id,
      });
    } else {
      // Fallback: copy to clipboard
      navigator.clipboard.writeText(window.location.origin + '/new/' + id);
      alert('Link copied to clipboard!');
    }
  };

  return (
    <div className="news-card">
      {/* Badge de catégorie */}
      <div className="news-badge"><MultiLingualContent contentID="category" /></div>

      {/* Date stylisée */}
      <div className="news-date">
        <span className="news-date-day">{dateInfo.day}</span>
        <span className="news-date-month">{dateInfo.month}</span>
      </div>

      {/* Image */}
      <div className="news-image-container">
        <div 
          className="news-image"
          style={{
            backgroundImage: `url(${endpointImg + (sampleImg || '/default-news.jpg')})`,
          }}
        />
      </div>

      {/* Contenu */}
      <div className="news-content">
        {/* Métadonnées */}
        <div className="news-meta">
          <div className="meta-item">
            <FontAwesomeIcon icon={faCalendarAlt} className="meta-icon" />
            <span>{dateInfo.month} {dateInfo.year}</span>
          </div>
          <div className="meta-item">
            <FontAwesomeIcon icon={faClock} className="meta-icon" />
            <span><MultiLingualContent contentID="readTime" /></span>
          </div>
        </div>

        {/* Titre */}
        <div className="news-title">
          <h3>
            <Link to={`/new/${id}`} style={{ color: 'inherit', textDecoration: 'none' }}>
              {getLocalizedTitle()}
            </Link>
          </h3>
        </div>

        {/* Extrait */}
        <div className="news-excerpt">
          {cleanHTML(getLocalizedDesc())}
        </div>

        {/* Actions */}
        <div className="news-actions">
          <Link to={`/new/${id}`} className="read-more-btn">
            <MultiLingualContent contentID="readMore" />
            <FontAwesomeIcon icon={faArrowRight} className="read-more-icon" />
          </Link>
          <button className="share-btn" onClick={handleShare}>
            <FontAwesomeIcon icon={faShareAlt} />
          </button>
        </div>
      </div>
    </div>
  );
};

export default NewsItem;